__webpack_require__.p = "/offer-content-generator-stream/referrals-hub/";